import { CONSENT_CHANGED_EVENT, hasPerformanceConsent } from '../consent/cookieConsent';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const GA_ID = process.env.REACT_APP_GA_ID;

let loaded = false;
let currentPath: string | null = null;

const isActive = () => !!GA_ID && hasPerformanceConsent();

const loadGA = () => {
  if (!GA_ID || loaded) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // gtag.js ต้องการ Arguments object ไม่ใช่ array
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
};

// ส่งเฉพาะ pathname ไม่ส่ง query string เพราะบางหน้า (เช่น reset-password) มี key ลับอยู่ใน URL
export const trackPageView = (path: string) => {
  currentPath = path;
  if (!isActive()) return;
  loadGA();
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: `${window.location.origin}${path}`,
    page_title: document.title,
  });
};

export const trackEvent = (name: string, params: Record<string, unknown>) => {
  if (!isActive()) return;
  loadGA();
  window.gtag('event', name, params);
};

export const startConsentListener = () => {
  const handler = () => {
    if (currentPath) trackPageView(currentPath);
  };
  window.addEventListener(CONSENT_CHANGED_EVENT, handler);
  return () => window.removeEventListener(CONSENT_CHANGED_EVENT, handler);
};

export interface GaItem {
  item_id: string | number;
  item_name: string;
  price: number;
  quantity?: number;
  item_variant?: string;
}

export const trackViewItem = (currency: string, item: GaItem) =>
  trackEvent('view_item', { currency, value: item.price, items: [item] });

export const trackAddToCart = (currency: string, item: GaItem) =>
  trackEvent('add_to_cart', {
    currency,
    value: item.price * (item.quantity ?? 1),
    items: [item],
  });

export const trackBeginCheckout = (currency: string, value: number, items: GaItem[]) =>
  trackEvent('begin_checkout', { currency, value, items });

export const trackPurchase = (
  transactionId: string,
  currency: string,
  value: number,
  items: GaItem[],
) => trackEvent('purchase', { transaction_id: transactionId, currency, value, items });
